import React, {useState, useEffect, useRef} from 'react'
import Modal from "react-modal";
import axios from 'axios'
import SelectSearch from 'react-select-search'
import fuzzySearch from '../common/fuzzySearch'
import {rankingsDevices, languagesCodes, configBaseUrl} from '../common/data'
import SelectAddress from "./SelectAddress";
import ShareLink from 'react-twitter-share-link';
import SharefbLink from 'react-facebook-share-link';
import TrialUserRegistrationForm from "../common/TrialUserRegistrationForm";
import SaveReport from "./SaveReport";
import ActiveAddresses from "./ActiveAddresses";
import {frequencyMonth, frequencyWeek} from "../common/data/dataTools";
import LocationForm from "../common/LocationForm";

const RankingsLive = props => {

	console.log('in RankingsLive - b412')

	const toolName = 'search_simulator'
	const toolUrl = 'search_simulator'
	const toolType = 'search'
	const featureId = 'SEARCH_SIMULATOR_SEARCHES'

	const { env, devmode, params, mode } = props

	let publicUrl = configBaseUrl[env] + 'build/'
	let baseUrl = configBaseUrl[env]
	const cannotUseDevMode = ['live', 'staging']
	if (!cannotUseDevMode.includes(env) && devmode === 'Y')
		baseUrl = baseUrl + 'app_dev.php/'

    const GoogleMapsApiKey = 'AIzaSyCdfz_s4qctDCF_LiGft5y9wA0HdHWqgYU'

	const [location, setLocation] = useState(false)
	const [accountLevel, setAccountLevel] = useState('BASIC')
	const [usageCount, setUsageCount] = useState(0)
	const [maxUsage, setMaxUsage] = useState(0)
	const [isMMUser, setIsMMUser] = useState(false)
	const [userId, setUserId] = useState(0)
	const [registeredForExtendedUsage, setRegisteredForExtendedUsage] = useState(false)
	const [trialUserRegistered, setTrialUserRegistered] = useState(false)

	const [country, setCountry] = useState('')
	const [countryName, setCountryName] = useState('')
	const [state, setState] = useState('')
	const [stateName, setStateName] = useState('')
	const [city, setCity] = useState('')
	const [cityName, setCityName] = useState('')
	const [SelectedCity, setSelectedCity] = useState([])
	const [postcode, setPostcode] = useState('')
	const [address, setAddress] = useState('')
	const [displayAddress, setDisplayAddress] = useState('')
	const [currentDisplayAddress, setCurrentDisplayAddress] = useState('')
	const [cityNameForAutoPopulate, setCityNameForAutoPopulate] = useState('')

	const [lat, setLat] = useState()
	const [lng, setLng] = useState()
	const [initialLat, setInitialLat] = useState(null)
	const [initialLng, setInitialLng] = useState(null)

	const [keyword, setKeyword] = useState('')
	const [lang, setLang] = useState('EN')
	const [engine, setEngine] = useState('google')

	const [states, setStates] = useState([])
	const [cities, setCities] = useState([])
	const [postcodes, setPostcodes] = useState([])

	const [statesLoaded, setStatesLoaded] = useState(false)
	const [citiesLoaded, setCitiesLoaded] = useState(false)
	const [defaultState, setDefaultState] = useState('')
	const [defaultCity, setDefaultCity] = useState('')

	const [primaryDevice, setPrimaryDevice] = useState(93)
	const [secondaryDevice, setSecondaryDevice] = useState(63)
	const [submitted, setSubmitted] = useState(false)
	const [validForm, setValidForm] = useState(false)
	const [autoSubmitFormWhenReady, setAutoSubmitFormWhenReady] = useState(false)
	const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
	const [submitButtonLabel, setSubmitButtonLabel] = useState('RUN LIVE TEST')
	const [usageAllowed, setUsageAllowed] = useState(true)
	const [defaultLocationParamsExists, setDefaultLocationParamsExists] = useState(false)

	const [allActiveAddresses, setAllActiveAddresses] = useState([])
	const [allAddressesModalIsOpen, setAllAddressesModalIsOpen] = useState(false);

	const [populatedPostCode, setPopulatedPostCode] = useState('')
	const [populatedAddress, setPopulatedAddress] = useState('')
	const [displayCityPostCodeMessage, setDisplayCityPostCodeMessage] = useState(false)
	const [displayCityNotHereMessage, setDisplayCityNotHereMessage] = useState(false)

	const [shareUrlLink, setShareUrlLink] = useState('')
	const [shareUrlText, setShareUrlText] = useState('')
	const [shareFbUrlLink, setShareFbUrlLink] = useState('')

	const [displayTrialUserRegistrationFormModalIsOpen, setDisplayTrialUserRegistrationFormModalIsOpen] = useState(false);

	const [saveTestPopUpIsOpen, setSaveTestPopUpIsOpen] = useState(false)
    const [saveTestData, setSaveTestData] = useState([])
    const [allActiveAddressPopusIsOpen, setAllActiveAddressPopusIsOpen] = useState(false)
   	const [selectedFrequency,SetSelectedFrequency] = useState('1')
    const [submitButtonHidden,setSubmitButtonHidded] = useState('')
    const [nextButtonHidden,setNextButtonHidden]=useState('hidden')
    const [frequencyText,setFreqencyText] = useState('')
    const [displayClass, setDisplayClass] = useState('hidden')
    const [frequencyAmount,setFrequencyAmount] = useState('')
    const [frequencyAmounts, setFrequencyAmounts] = useState([])
    const [displayFrequencyAmount,setDisplayFrequencyAmount] = useState('hidden')
    const [selectedFrequencyName,setSelectedFrequencyName] = useState('Once Only')
    const [locality, setLocality] = useState('nonlocal')

    const twitterTab = useRef(null)
    const fbTag = useRef(null)

    let todaysDate = new Date()
    let dateDayOfMonth = todaysDate.getDate();
    let dateDayOfWeek = todaysDate.getDay() + 1;
	// Mon dd, YYYY
	const thisMonth = todaysDate.toLocaleString('default', { month: 'short' });
	var formattedTodaysDate = thisMonth + " " + ("0" + todaysDate.getDate()).slice(-2) + ", " + todaysDate.getFullYear()

    const saveTestModalStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
			border: 'none',
            padding: 0,
            background: 'transparent',
            transition: 'all 5000ms ease-in-out'
        }
      };

	const standardModalStyles = {
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			transform: 'translate(-50%, -50%)',
			border: 'none',
			padding: 0,
			background: 'transparent'
		},
	};

	// open edit addresses modal
    function allAddressesModalOpen() {
        setAllAddressesModalIsOpen(true);
    }

	// close all addresses modal
    function allAddressesModalClose() {
        setAllAddressesModalIsOpen(false);
    }

	const handleFetchStates = Country => {
		console.log('in handleFetchStates, Country',Country)
		axios.get(baseUrl + 'tools/get-states?country_code=' + Country)
			.then(r => {
				// load states
				setStates(r.data)

				// reset dropdowns
				setTimeout(() => {
					setState('')
					setCities([])
					setCity('')
					setPostcodes([])
					setPostcode('')
					setAddress('')
					console.log('reset dropdowns')

					// set that states are loaded, so  we can set a default state, if we have one
					setStatesLoaded(true)
				}, 100);
			})
			.catch(e => { console.log(e) })
	}

	const handleFetchCities = State => {
		console.log('in handleFetchCities, State=',State)
		axios.get(baseUrl + 'tools/get-cities?returnFormat=jsonValues&state=' + State)
			.then(r => {
				setCities(r.data)
				setTimeout(() => {
					// set that states are loaded, so  we can set a default state, if we have one
					setCitiesLoaded(true)
				}, 100)
			})
   			.catch(e => {
   				console.log(e)
   			})
   	}

   	const handlePostcode = (postcode) => {
   		console.log('in handlePostcode')
        setPostcode(postcode)
   		setPopulatedPostCode('')
   	}

   	const handlePopulatedPostcode = (populatedPostcode) => {
   		console.log('in handlePostcode')
        setPostcode('')
   		setPopulatedPostCode(populatedPostcode)
	}

	const handleFetchPostcodes = City => {
		console.log('in handleFetchPostcodes, City=',City)
		axios.get(baseUrl + 'tools/get-postcodes?returnFormat=jsonValues&city=' + City)
			.then(r => { setPostcodes(r.data) })
			.catch(e => { console.log(e) })
	}

	const handleSetCountry = (Country) => {
		console.log('in handleSetCountry, Country=',Country)
		setCountry(Country)
		handleFetchStates(Country)
	}

	const handleSetState = (State) => {
		console.log('in handleSetState, State=',State)
		setState(State)
		handleFetchCities(State)
	}

	const generateLatLngFromAddress = () => {
     // console.log('generateLatLngFromAddress', 'thisDisplayAddress',cityName + ', ' + stateName + ', ' + countryName,'postcode',postcode, 'populatedPostCode',populatedPostCode, 'address',address, 'SelectedCity',SelectedCity, 'initialLat', initialLat)

     let latLngFound = false
		let thisLat = initialLat
		let thisLng = initialLng

		if( initialLat !== null ) {
			setInitialLat(null)
			setInitialLng(null)
			handleFetchEmulatorHtml(thisLat,thisLng)
		} else {
			// update display address
			let thisDisplayAddress = cityName + ', ' + stateName + ', ' + countryName

			// no zip or address
			if (postcode === '' && populatedPostCode === '' && address === '' && SelectedCity) {
				if (SelectedCity.length > 0) {
					let cityParts = JSON.parse(SelectedCity)
					if (cityParts.lat !== 0 || cityParts.lng !== 0) {
						thisLat = cityParts.lat
						thisLng = cityParts.lng
						latLngFound = true
					}
				}
			}
			// zip but no address
			if ((postcode !== '' || populatedPostCode !== '') && address === '') {
				if (postcode !== '') {
					let postcodeParts = JSON.parse(postcode)
					if (postcodeParts.lat !== 0 || postcodeParts.lng !== 0) {
						thisLat = postcodeParts.lat
						thisLng = postcodeParts.lng
						latLngFound = true
						thisDisplayAddress = postcodeParts.postcode + ', ' + thisDisplayAddress
					}
				} else {
					thisDisplayAddress = populatedPostCode + ', ' + thisDisplayAddress
				}
			}

			setDisplayAddress(cityName + ', ' + stateName + ', ' + countryName)
			setCurrentDisplayAddress(cityName + ', ' + state + ', ' + country)
			// setCurrentDisplayAddress(thisDisplayAddress)

			if (latLngFound) {
				setLat(thisLat)
				setLng(thisLng)

				// place marker for this address on the map
				// let tempMapLocations = []
				// tempMapLocations.push({'lat': thisLat, 'lng': thisLng, 'address': thisDisplayAddress})
				// setMapLocations(tempMapLocations)
				// setMapPos({'lat': thisLat, 'lng': thisLng})

				handleFetchEmulatorHtml(thisLat, thisLng)
			} else {
				let addressToEncodeArr = []
				if (address !== '')
					addressToEncodeArr.push(address)
				if (populatedPostCode !== '')
					addressToEncodeArr.push(populatedPostCode)

				if ((city === '' || !isNaN(city)) && cityName !== '')
					addressToEncodeArr.push(cityName)
				else if (city !== '')
					addressToEncodeArr.push(city)

				if ((state === '' || !isNaN(state)) && stateName !== '')
					addressToEncodeArr.push(stateName)
				else if (state !== '')
					addressToEncodeArr.push(state)

				if ((country === '' || !isNaN(country)) && countryName !== '')
					addressToEncodeArr.push(countryName)
				else
					addressToEncodeArr.push(country)

				let addressToEncode = addressToEncodeArr.join()

				// console.log('generateLatLngFromAddress', 'addressToEncodeArr', addressToEncodeArr, 'addressToEncode', addressToEncode)
				let encodeAddressUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + addressToEncode + '&key=' + GoogleMapsApiKey
				fetch(encodeAddressUrl)
					.then(res => res.json())
					.then(res => {
						if (res.status === 'OK') {
							if (res.results[0].geometry.location.lat)
								thisLat = res.results[0].geometry.location.lat
							if (res.results[0].geometry.location.lng)
								thisLng = res.results[0].geometry.location.lng

							setLat(thisLat)
							setLng(thisLng)

							// place marker for this address on the map
							let tempMapLocations = []
							tempMapLocations.push({'lat': thisLat, 'lng': thisLng, 'address': thisDisplayAddress})
							// setMapLocations(tempMapLocations)
							// setMapPos({'lat': thisLat, 'lng': thisLng})

							handleFetchEmulatorHtml(thisLat, thisLng)
						} else if (res.status === 'ZERO_RESULTS') {
							console.log('Unable to process location')
						}
					})
			}
		}
 	}

	// const getItemInArray = (arr, matchValue, matchField) => {
	// 	let itemParts = []
	// 	for (let i = 0, iLen = arr.length; i < iLen; i++) {
	// 		itemParts = JSON.parse(arr[i].value)
	// 		if (itemParts[matchField] === matchValue) return arr[i].value;
	// 	}
	// }

	const getItemInArrayByName = (arr, matchValue) => {
		for (var i = 0, iLen = arr.length; i < iLen; i++) {
			if (arr[i].name === matchValue) return arr[i].value
		}
		if( arr.length > 0 )
			return arr[0].value
	}

    const handleSetCity = (SelectedCity) => {
        console.log('in handleSetCity, SelectedCity=', SelectedCity)

		setSelectedCity(SelectedCity)
		setDisplayCityPostCodeMessage(false)
		setDisplayCityNotHereMessage(false)

		if (SelectedCity) {
			try {
				let cityParts = JSON.parse(SelectedCity)
				// setState(cityParts.stateName) // this line caused US locations to overwrite with non-numeric value that does not match items in the state selector
				if (cityParts.id === -1 || cityParts.id === 0) {
					setCity('')
                    setCityName('')
					setPostcodes([])
					setPostcode('')
					setPopulatedPostCode('')
					if( cityParts.id === -1 )
						setDisplayCityNotHereMessage(true)
					if( cityParts.id === 0 )
						setDisplayCityPostCodeMessage(true)
				} else {
					// only fetch postcodes if useGeoTables=1 in geoCountry
					if (cityParts.id > 0 && cityParts.useGeoTables)
						handleFetchPostcodes(cityParts.id)
					if (cityParts.cityName) {
						setCity(cityParts.cityName)
                        setCityName(cityParts.cityName)
					}
                    if (cityParts.stateName)
                        setStateName(cityParts.stateName)
                    if (cityParts.countryName)
                        setCountryName(cityParts.countryName)
				}
                console.log('lat/lng', cityParts.lat,cityParts.lng)

                if (cityParts.lat === 0 || cityParts.lng === 0){
                    console.log('no lat/lng', cityName)
                    // let thisCityName = cityName
                    // if( e && e.name ) {
                    //     console.log('e.name',e.name)
                    //     if (e.name)
                    //         thisCityName = e.name
                    // }
                }
                else {
                    if (cityParts.lat)
                        setLat(cityParts.lat)
                    if (cityParts.lng)
                        setLng(cityParts.lng)
                }
			} catch (exception) {
				console.log('not json value')
			}
		}
	}

	// will only run once, after the state list has loaded the first time
	useEffect(() => {
		console.log('statesLoaded',statesLoaded, defaultState)
		if( statesLoaded && ( ( !isNaN(defaultState) && defaultState > 0 )  || (defaultState !== '') )){
			// set state
			handleSetState(defaultState)
		}
	}, [statesLoaded])
	
	// will only run once, after the city list has loaded the first time
	useEffect(() => {
		console.log('citiesLoaded',citiesLoaded, defaultCity)
		if( citiesLoaded && defaultCity !== ''){
			let _defaultCity = getItemInArrayByName(cities,defaultCity)
			console.log('defaultCity',_defaultCity)
			// set city
			handleSetCity(_defaultCity)
		}
	}, [citiesLoaded])


	useEffect(() => {
		let set_location = true

		console.log('params',params)
		if( params > '') {
			let paramsParts = JSON.parse(params)

			if (paramsParts.keyword ) {
				setKeyword(paramsParts.keyword)
				setAutoSubmitFormWhenReady(true)
			}

			if (paramsParts.city)
				setDefaultCity(paramsParts.city)

			if (paramsParts.stateId)
				setDefaultState(paramsParts.stateId)
			else if (paramsParts.state)
				setDefaultState(paramsParts.state)

			if (paramsParts.country_code) {
				set_location = false
				handleSetCountry(paramsParts.country_code)
			}

			if (paramsParts.address ) {
				setAddress(paramsParts.address)
			}
			if (paramsParts.lang) {
				setLang(paramsParts.lang)
			}
			if (paramsParts.device1) {
				setPrimaryDevice(paramsParts.device1)
			}
			if (paramsParts.device2) {
				setSecondaryDevice(paramsParts.device2)
			}
			if (paramsParts.latitude && paramsParts.longitude) {
				setInitialLat(paramsParts.latitude)
				setInitialLng(paramsParts.longitude)
			}
		}

		axios.get(baseUrl + 'tools/can-use-tool/' + toolUrl + '?set_location=' + set_location + '&mode=' + mode)
			.then(r => {
				if( r.data.location )
					setLocation(r.data.location)
				if( r.data.accountLevel )
					setAccountLevel(r.data.accountLevel)

				if( mode === 'demo' ) {
					if (r.data.userId && r.data.userId > 0) {
						setUserId(r.data.userId)
						// setPublicUsage(false)
						if (r.data.isMMUser)
							setIsMMUser(r.data.isMMUser)
						if (r.data.accountLevel)
							setAccountLevel(r.data.accountLevel)
					} else {
						// setPublicUsage(true)
						if (r.data.publicUsageAccessDetails.maxUsage)
							setMaxUsage(r.data.publicUsageAccessDetails.maxUsage)
						if (r.data.publicUsageAccessDetails.usageCount)
							setUsageCount(r.data.publicUsageAccessDetails.usageCount)
					}
				}

				if( set_location ) {
					if (r.data.location.city)
						setDefaultCity(r.data.location.city)

					if (r.data.location.stateId)
						setDefaultState(r.data.location.stateId)
					else if (r.data.location.state)
						setDefaultState(r.data.location.state)
					else if (r.data.location.region_name)
						setDefaultState(r.data.location.region_name)

					if (r.data.location.country_code) {
						handleSetCountry(r.data.location.country_code)
					}
				}
			})
			.catch(e => {
				console.log(e)
			})

		if( mode === 'member') {
			axios.get(baseUrl + 'mm-api/get-all-addresses-for-autopopulate/')
				.then(r => {
					console.log('mm-api/get-all-addresses-for-autopopulate response:', r.data)
					setAllActiveAddresses(r.data.activeAddresses)
				})
				.catch(e => {
					console.log(e)
				})
		}

        window.addEventListener('copyToClipboard',(data)=>{
	        console.log('copyToClipboard data',data.detail);
	            if(data.detail.sharingLink != '')
	            {
	            	navigator.clipboard.writeText(data.detail.sharingLink)
	            }
	          window.removeEventListener('copyToClipboard', null)
	    })

	    window.addEventListener('twitterbtn',(data)=>{
	        console.log('twitterbtn data',data.detail);
	            if(data.detail.url != '')
	            {
	            	setShareUrlLink(data.detail.url)
	            	setShareUrlText(data.detail.message)
	            	twitterTab.current.click()
	            }
	          window.removeEventListener('twitterbtn', null)
	    })

	    window.addEventListener('facebookbtn',(data)=>{
	        console.log('facebookbtn data',data.detail);
	            if(data.detail.url != '')
	            {
	            	fbTag.current.click()
	            	setShareFbUrlLink(data.detail.url)
	            }
	          window.removeEventListener('facebookbtn', null)
	    })

	}, [])

	useEffect(()=>{

           window.addEventListener('setPopUpFunction',(data)=>{
               console.log('received popup data',data.detail);
                   if(data.detail.type==='popup_data')
                   {
                       if(data.detail.data)
                       {
                           console.log('popup_data');
                           console.log(data.detail.data)
                           console.log('frequencyAmount selected : ',selectedFrequency)
                           saveTestReportModalOpen();
                       }
                   }
           })

  },[]);
	useEffect(() => { validateForm() }, [ country, state, city, keyword, lang, primaryDevice, secondaryDevice ])

	if( mode === 'demo' ) {

		useEffect(() => {
			console.log('TUR - trialUserRegistered', trialUserRegistered)
			// will be updated after the user registers
			if( trialUserRegistered )
				setSubmitButtonDisabled(false)
				setUsageAllowed(true)
			}, [ trialUserRegistered ])

		useEffect(() => {
			if( setUsageAllowed)
				setSubmitButtonLabel('RUN LIVE TEST')
			else
				setSubmitButtonLabel('SIGN UP')
			}, [ setUsageAllowed ])

		useEffect(() => {
			console.log('TUR - usageCount or maxUsage changed', registeredForExtendedUsage, usageCount, maxUsage)
			checkUsage()
		}, [usageCount, maxUsage])
	}

	const checkUsage = () => {
		if (userId === 0 && !registeredForExtendedUsage && maxUsage > 0 && usageCount > maxUsage) {
			console.log('TUR - display reg form 1')
			setSubmitButtonDisabled(true)
			setUsageAllowed(false)
			setDisplayTrialUserRegistrationFormModalIsOpen(true)
		} else if (userId === 0 && registeredForExtendedUsage && maxUsage > 0 && usageCount > maxUsage) {
			setTimeout(() => {
				console.log('TUR - reload page 1')
				window.location.reload()
			}, 1000);
		}
	}

	const checkUsageOnSubmit = () => {
		if (userId === 0 && !registeredForExtendedUsage && maxUsage > 0 && usageCount === maxUsage) {
			console.log('TUR - display reg form 2')
			setSubmitButtonDisabled(true)
			setUsageAllowed(false)
			setDisplayTrialUserRegistrationFormModalIsOpen(true)
		} else if (userId === 0 && registeredForExtendedUsage && maxUsage > 0 && usageCount === maxUsage) {
			setTimeout(() => {
				console.log('TUR - reload page 2')
				// window.location.reload();
			}, 1000);
		}
	}

	const handleFetchEmulatorHtml = (_lat,_lng) => {
		let phoneIds = []
		if (primaryDevice > 0)
			phoneIds.push(primaryDevice)
		if (secondaryDevice > 0)
			phoneIds.push(secondaryDevice)

		var params = {
			'type': toolType,
			'tool': toolName,
			'feature_htmloutput': 0,
			'feature_htmloutputBot': 0,
			'feature_screenshothtmloutput': 0,
			// 'locid': city,
			'lat': _lat,
   			'lng': _lng,
			'state': state,
			'city': city,
			'suburb': postcode,
			'suburb_type': '',
			'address': address,
			'keyword': keyword,
			'engine': engine,
			'lang': lang,
			'phoneids_arr': phoneIds,
			'public_usage': mode !== 'member',
			'mm_mode': mode,
		};

		if( isNaN(country)) {
			params.country_code = country
			params.country = country
		}
		else
			params.country_id = country

		// console.log('params', params)

		axios.post(baseUrl + 'tools/display/' + toolUrl, {'params': params})
			.then(r => {
				document.getElementById('emulator_div').innerHTML = r.data
				setSubmitButtonDisabled(false);
				document.getElementById('emulator_placeholder').style.display = 'none';
			})
			.catch(e => {
				console.log(e)
			})
	}

	const checkPublicUsageAccess = () => {
		axios.get(baseUrl + 'tools/public_usage-access/' + featureId)
		.then(r => {
			console.log('public_usage-access response:', r.data)
			if( ! r.data.publicUsageAccess){
				setSubmitButtonDisabled(true)
				window.location.reload();
			}
		})
		.catch(e => {
			console.log(e)
		})
	}

	const validateForm = () => {
		setSubmitted(false)
  		let saveTestDataArray = {};
        saveTestDataArray['country'] = country;
        saveTestDataArray['state']= state;
        saveTestDataArray['city']=city;
        saveTestDataArray['keyword']=keyword;
        saveTestDataArray['lang']=lang;
        saveTestDataArray['postcode']=populatedPostCode?populatedPostCode:postcode;
        saveTestDataArray['address']=populatedAddress?populatedAddress:address;
        setSaveTestData(saveTestDataArray)
		// const isValidForm = country !== '' && state !== '' && city !== '' && keyword !== '' && lang !== '' &&  (primaryDevice > 0 || secondaryDevice > 0)
		const isValidForm = country !== '' && state !== '' && keyword !== '' && lang !== '' &&  (primaryDevice > 0 || secondaryDevice > 0)
		setValidForm(isValidForm)

		setSubmitButtonDisabled(!isValidForm)

		console.log('in validateForm, validForm=', isValidForm, autoSubmitFormWhenReady, country !== '', state !== '', city !== '', keyword !== '', lang !== '', (primaryDevice > 0 || secondaryDevice > 0))

		// auto-submit form on load (when form is valid and usage is allowed)
		if (isValidForm && autoSubmitFormWhenReady && usageAllowed) {
			setAutoSubmitFormWhenReady(false)
			setSubmitButtonDisabled(true)
			generateLatLngFromAddress()
		}
	}

	const submitFormClick = () => {
		console.log('in submitFormClick, validForm=',validForm)
		// set form as submitted (if valid)
		setSubmitted(validForm)

		if( validForm ) {
			if( mode === 'demo' ) {
				if( userId > 0 )
					handleFetchEmulatorHtml()
				else {
					if (usageAllowed) {
						if (usageCount < maxUsage) {
							setUsageCount(usageCount + 1)
							generateLatLngFromAddress()
							// handleFetchEmulatorHtml()
						} else
							checkUsageOnSubmit()
					} else if (!registeredForExtendedUsage) {
						setDisplayTrialUserRegistrationFormModalIsOpen(true)
					}
				}
			} else
				generateLatLngFromAddress()
				// handleFetchEmulatorHtml()
			setSubmitButtonDisabled(true)
		}
	}

	// close modal
	function displayTrialUserRegistrationFormModalClose() {
		setDisplayTrialUserRegistrationFormModalIsOpen(false)
	}

	const handleChooseMyAddress = (e) => {
		allAddressesModalOpen()
	}

	const handleAddress = (address) => {
		console.log('in handleAddress')

		setPopulatedAddress(address)
	}
	function saveTestReportModalOpen(){
        setSaveTestPopUpIsOpen(true);
    }
    function saveTestReportModalClose(){
        setSaveTestPopUpIsOpen(false);
    }

    function allActiveAddressModalOpen(){
        setSaveTestPopUpIsOpen(false);
        setAllActiveAddressPopusIsOpen(true);
    }
    function allActiveAddressModalClose(){

        setAllActiveAddressPopusIsOpen(false);
        setSaveTestPopUpIsOpen(true);
		setFrequencyAmount(frequencyAmount);

    }

    const settingDisplayLocality = (value) => {
       console.log('in set display locality .....');
       console.log(displayClass);

       if(value == 1){
               setDisplayClass('hidden')
               setSubmitButtonDisabled(false)
               setSubmitButtonHidded('')
               setNextButtonHidden('hidden')
               SetSelectedFrequency('1')
               setSelectedFrequencyName('Once Only')
               setDisplayFrequencyAmount('hidden')
               setFrequencyAmount(1)
       }
       if(value == 2){
               setDisplayClass('')
               setDisplayFrequencyAmount('');
               setFrequencyAmounts(frequencyWeek);
               setFrequencyAmount(dateDayOfWeek);
               setFreqencyText('now and then every');
               setSubmitButtonHidded('hidden')
               setNextButtonHidden('')
               setSubmitButtonDisabled(true)
               SetSelectedFrequency('2')
               setSelectedFrequencyName('Weekly')

       }
       if(value == 3){
               setDisplayFrequencyAmount('');
            setFrequencyAmounts(frequencyMonth)
            setFrequencyAmount(dateDayOfMonth)
            setFreqencyText('now and then on the')
            setDisplayClass('')
            setNextButtonHidden('')
            setSubmitButtonHidded('hidden')
            setSubmitButtonDisabled(true)
            setSelectedFrequencyName('Monthly')
               SetSelectedFrequency('3')
       }
       if(value == 4)
       {
               setDisplayClass('')
               setDisplayFrequencyAmount('hidden')
               setSubmitButtonHidded('hidden')
               setSubmitButtonDisabled(true)
               setNextButtonHidden('')
               SetSelectedFrequency('4')
               setSelectedFrequencyName('Daily')
       }
    }
    const setFrequencyAmountData=(e)=>{
    	console.log('in set frequnecy Amount Data section with frequency : '+ e)
    	setFrequencyAmount(e)
    }
	return (
		<div className='RankingsLive'>
			<div className='container-fluid'>
				<div className='row'>
					<ShareLink link={shareUrlLink} text={shareUrlText}>
					   {link => (
					      <a ref={twitterTab} href={link} target='_blank' className="hidden">Share this on Twitter</a>
					   )}
					</ShareLink>

					<SharefbLink link={shareFbUrlLink}>
					   {link => (
					      <a ref={fbTag} href={link} target='_blank' className="hidden">Share this on Facebook</a>
					   )}
					</SharefbLink>
					<div className='tab-content live-testing'>
						<div id="simulator_control_tab">
							<form className='controls' autoComplete='chrome-off'>
								<div className={'row' + ( allActiveAddresses.length > 0 ? ' ' : ' hidden' )}>
				                  <div className="col-md-12">
				                    <a className="choose-my-address" onClick={(e) => handleChooseMyAddress(e)}><span className="material-icons">book</span>Choose From My Address Book</a>
				                  </div>
				                </div>
								<LocationForm
								  handleSetCountry={handleSetCountry}
								  handleSetState={handleSetState}
								  handleSetCity={handleSetCity}
								  SelectedCity={SelectedCity}
								  submitted={submitted}
								  country={country}
								  state={state}
								  states={states}
								  city={city}
								  cities={cities}
								  postcodes={postcodes}
								  populatedPostCode={populatedPostCode}
								  handlePostcode={handlePostcode}
								  handlePopulatedPostcode={handlePopulatedPostcode}
								  populatedAddress={populatedAddress}
								  address={address}
								  setAddress={setAddress}
								  setPostcode={setPostcode}
								  postcode={postcode}
								  displayCityPostCodeMessage={displayCityPostCodeMessage}
								  displayCityNotHereMessage={displayCityNotHereMessage}
							  />
								<div className='row mt-10 mb-10'>
									<div className='col-sm-6'>
										<label className='control-label'>Search Term <span className='required'>*</span></label>
										<div className={submitted && keyword === '' ? 'form-group has-feedback has-error' : 'form-group has-feedback'}>
											<div className='input-section'>
												<input type='text' value={keyword} onChange={e => setKeyword(e.target.value)} className='form-control' />
											</div>
											{submitted && keyword === '' && (<span className='error'>Please enter a search term</span>)}
										</div>
									</div>
									<div className='col-sm-6'>
										<label className='control-label'>Language <span className='required'>*</span></label>
										<div className='form-group has-feedback has-error'>
											<div className='input-section adjusted-selector-width'>
												<SelectSearch
													search
													autoComplete='nope'
													emptyMessage='Not found'
													placeholder='Select a language'
													value={lang}
													options={languagesCodes}
													filterOptions={fuzzySearch}
													onChange={setLang} />
											</div>
											{submitted && lang === '' && (<span className='error'>Please select a language</span>)}
										</div>
									</div>
								</div>
								<div className='row'>
									<div className='col-xs-12 col-sm-6'>
										<label className='control-label'>First Device <span className='required'>*</span></label>
										<div className='form-group has-feedback has-error'>
											<div className='input-section'>
												<SelectSearch
													search
													allowEmpty={true}
													emptyMessage='Not found'
													placeholder='Select a device'
													value={primaryDevice}
													options={rankingsDevices}
													filterOptions={fuzzySearch}
													onChange={setPrimaryDevice} />
											</div>
											{submitted && primaryDevice === '' && (<span className='error'>Please choose a device from the list above</span>)}
										</div>
									</div>
									<div className='col-xs-12 col-sm-6'>
										<label className='control-label'>Second Device (optional)</label>
										<div className='form-group'>
											<div className='input-section'>
												<SelectSearch
													search
													allowEmpty={true}
													emptyMessage='Not found'
													placeholder='Select a device'
													value={secondaryDevice}
													options={rankingsDevices}
													filterOptions={fuzzySearch}
													onChange={setSecondaryDevice} />
											</div>
										</div>
									</div>
								</div>
								<div className='row'>
									<div className="col-xs-12 text-center text-center-xs mt-20">
										<input disabled={submitButtonDisabled} type="button" className="btn btn-primary" value={submitButtonLabel} onClick={() => submitFormClick()} />
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>

			<div className="search-results-container tool-ui">
				<div id='emulator_div' className="results-wrapper"></div>
				<div id='emulator_placeholder' className='results-wrapper'>
					<div className='phone-wrap'>
						<img src="/img/mobile-placeholder.webp" />
					</div>
					<div className='phone-wrap'>
						<img src="/img/desktop-placeholder.webp" />
					</div>
				</div>
			</div>

			<div className={'row' + (mode === 'member' ? ' mb-80' : '')}>
				<div className="col-xs-12">
					<div className={mode === 'member' ? 'pa-20 bg-white' : 'pt-20'}>
						<div className="row">
							<div className="col-xs-12 text-center captcha-note">
								Note about CAPTCHAs:<br />
								As you explore our Toolset, you may encounter CAPTCHA in your searches. Please click
								through the CAPTCHA, as this will help Google recognize that our users are indeed humans
								and not robots. Thanks!
							</div>
						</div>
					</div>
				</div>
			</div>

			<Modal
                isOpen={allAddressesModalIsOpen}
                onRequestClose={allAddressesModalClose}
                contentLabel="Select Address"
                style={standardModalStyles}
            >
                <SelectAddress
                    baseUrl={baseUrl}
                    publicUrl={publicUrl}
                    allAddressesModalClose={allAddressesModalClose}
                    setPopulatedPostCode={setPopulatedPostCode}
                    setPostcode={setPostcode}
                    setPopulatedAddress={setPopulatedAddress}
                    handleSetCountry={handleSetCountry}
                    handleSetState={handleSetState}
                    handleSetCity={handleSetCity}
                >
                </SelectAddress>
            </Modal>

			<Modal
				isOpen={displayTrialUserRegistrationFormModalIsOpen}
				onRequestClose={displayTrialUserRegistrationFormModalClose}
				contentLabel="User Registration"
				style={standardModalStyles}
			>
				<TrialUserRegistrationForm
					publicUrl={publicUrl}
					baseUrl={baseUrl}
					toolUrl={toolUrl}
					setUsageAllowed={setUsageAllowed}
					setRegisteredForExtendedUsage={setRegisteredForExtendedUsage}
					setMaxUsage={setMaxUsage}
					setTrialUserRegistered={setTrialUserRegistered}
					displayTrialUserRegistrationFormModalClose={displayTrialUserRegistrationFormModalClose}
				/>
			</Modal>

            <Modal
                    isOpen={saveTestPopUpIsOpen}
                    onRequestClose={saveTestReportModalClose}
                    contentLabel="Save Test"
                       style={saveTestModalStyles}
            >
               <SaveReport
                    baseUrl={baseUrl}
                    publicUrl={publicUrl}
                    SaveReportPopUpClose={saveTestReportModalClose}
                    saveTestData={saveTestData}
                    allActiveAddressModalOpen = {allActiveAddressModalOpen}
                    accountLevel = {accountLevel}
                    selectedFrequency={selectedFrequency}
                    SetSelectedFrequency={SetSelectedFrequency}
                    settingDisplayLocality={settingDisplayLocality}
                    submitButtonHidden={submitButtonHidden}
                    setSubmitButtonHidded={setSubmitButtonHidded}
                    nextButtonHidden={nextButtonHidden}
                    setNextButtonHidden={setNextButtonHidden}
                    frequencyText={frequencyText}
                    setFreqencyText={setFreqencyText}
                    displayClass={displayClass}
                    setDisplayClass={setDisplayClass}
                    frequencyAmount={frequencyAmount}
                    setFrequencyAmount={setFrequencyAmount}
                    frequencyAmounts={frequencyAmounts}
                    setFrequencyAmounts={setFrequencyAmounts}
                    displayFrequencyAmount={displayFrequencyAmount}
                    setDisplayFrequencyAmount={setDisplayFrequencyAmount}
                    selectedFrequencyName={selectedFrequencyName}
                    setSelectedFrequencyName={setSelectedFrequencyName}
                    locality={locality}
                    setLocality={setLocality}
                    setFrequencyAmountData={setFrequencyAmountData}
                    >
                </SaveReport>
            </Modal>
            <Modal
                	isOpen={allActiveAddressPopusIsOpen}
                    onRequestClose={allActiveAddressModalClose}
                    contentLabel="For Save Test"
                    style = {standardModalStyles}
            >
                <ActiveAddresses
                    accountLevel={accountLevel}
                    baseUrl={baseUrl}
                    publicUrl={publicUrl}
                    allActiveAddressModalClose={allActiveAddressModalClose}
                    locality={locality}
                    frequencyAmount={frequencyAmount}
                    selectedFrequency={selectedFrequency}
                    selectedFrequencyName={selectedFrequencyName}
                    saveTestData={saveTestData}
                    >
                </ActiveAddresses>
            </Modal>
		</div>
	)
}

export default RankingsLive